'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dRule$002dDescription$0024$0024anon$0024105 from "./presto.types$-Rule-Description$$anon$105.js";
var $p;
/** @constructor */
function $c_Lpresto_types$RuleDescription$() {
  this.caB = null;
  this.caC = false;
  this.caD = null;
  this.caE = false;
}
export { $c_Lpresto_types$RuleDescription$ as $c_Lpresto_types$RuleDescription$ };
$p = $c_Lpresto_types$RuleDescription$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$RuleDescription$;
/** @constructor */
function $h_Lpresto_types$RuleDescription$() {
}
export { $h_Lpresto_types$RuleDescription$ as $h_Lpresto_types$RuleDescription$ };
$h_Lpresto_types$RuleDescription$.prototype = $p;
$p.cIl = (function() {
  if ((!this.caC)) {
    this.caB = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.caC = true;
  }
  return this.caB;
});
$p.adM = (function() {
  if ((!this.caE)) {
    this.caD = new $j_presto$002etypes$0024$002dRule$002dDescription$0024$0024anon$0024105.$c_Lpresto_types$RuleDescription$$anon$105(this);
    this.caE = true;
  }
  return this.caD;
});
var $d_Lpresto_types$RuleDescription$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$RuleDescription$, "presto.types$RuleDescription$", ({
  a1f: 1,
  D: 1
}));
export { $d_Lpresto_types$RuleDescription$ as $d_Lpresto_types$RuleDescription$ };
var $n_Lpresto_types$RuleDescription$;
function $m_Lpresto_types$RuleDescription$() {
  if ((!$n_Lpresto_types$RuleDescription$)) {
    $n_Lpresto_types$RuleDescription$ = new $c_Lpresto_types$RuleDescription$();
  }
  return $n_Lpresto_types$RuleDescription$;
}
export { $m_Lpresto_types$RuleDescription$ as $m_Lpresto_types$RuleDescription$ };
//# sourceMappingURL=presto.types$-Rule-Description$.js.map
